import { PartnerUserJSON } from '@jurnee/common/src/entities/PartnerUser';
import { createEntityAdapter } from '@reduxjs/toolkit';

export const partnerUsersAdapter = createEntityAdapter<PartnerUserJSON>();